import React, { ReactElement } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { AccordionItem as Item, AccordionItemProps as Props } from '@szhsin/react-accordion';
import { ItemKey } from "@szhsin/react-accordion/types/utils/constants";
import { TransitionState } from "react-transition-state";
import '../../../assets/styles/accordion.css';

export const DefaultAccordionProviderOptions = {
    allowMultiple: true,
    transition: false,
    transitionTimeout: 250,
    initialEntered: true,
    onStateChange: (event: { key: ItemKey; current: TransitionState }) => { console.log(event) }
}

interface AccordionItemProps extends Omit<Props, "header"> {
    header: string | ReactElement,
    headingLevel?: 2 | 3 | 4 | 5 | 6,
    isHidden?: boolean,
    ariaLabel?: string,
    textRight?: string,
}

export default function AccordionItem(props: AccordionItemProps): ReactElement {
    const { header, className, headingLevel = 2, buttonProps, panelProps, isHidden, ariaLabel, textRight, ...rest } = props
    const exitedIcon = <FontAwesomeIcon icon={faPlus} /> // <FontAwesomeIcon icon={faChevronDown} />
    const enteredIcon = <FontAwesomeIcon icon={faMinus} /> // <FontAwesomeIcon icon={faChevronUp} />
    const HeadingTag = `h${headingLevel}` as keyof JSX.IntrinsicElements;

    const headerText = typeof header === 'string' ? header : undefined;
    const buttonAriaLabel = ariaLabel ?? headerText
    const classNameStr = typeof className === 'string' ? className : '';

    return (
        <Item
            {...rest}
            header={({ state }) =>
                <div className='accordion-header'>
                    <HeadingTag>{header}</HeadingTag>
                    <div>
                        <h2 className="inline-block">{textRight}</h2>{" "}
                        {
                            state.status.toLowerCase().includes("exit") ?
                                exitedIcon
                                :
                                enteredIcon
                        }
                    </div>
                </div>
            }
            className={`accordion-container`}
            buttonProps={{
                'className': `accordion-header-btn${classNameStr ? ` ${classNameStr}` : ''}`,
                ...(buttonAriaLabel ? { 'aria-label': buttonAriaLabel } : {})
            }}
            panelProps={{
                'className': "accordion-content",
                ...(isHidden || classNameStr.includes('invisible-accordion')
                    ? { 'role': 'presentation', 'aria-labelledby': undefined }
                    : headerText ? { 'ariaLabel': headerText } : { 'role': 'presentation', 'aria-labelledby': undefined })
            }}
            headingTag={`h${headingLevel}`}
        />
    )
}

